export default "__VITE_ASSET__1dCmkChH__"